module.exports = __webpack_public_path__ + "static/google-cloud-certificate-ed3b44c3612641b9ce73f59836cd1028.png";